/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT MODIFY.
 */

export const radiusFull = '999em';
export const radiusSmall = '0.125rem';
export const borderWidthLarge = '0.1875rem';
export const borderWidthMedium = '0.125rem';
export const borderWidthSmall = '0.0625rem';
export const colorBackgroundDanger = '#f5e9e8';
export const colorBackgroundPrimary = '#ffffff';
export const colorBackgroundSecondary = '#f4f4f5';
export const colorBackgroundSideNav = '#021c6b';
export const colorBackgroundSuccess = '#ddefe6';
export const colorBackgroundSurface = '#ffffff';
export const colorBackgroundTertiary = '#e4e6e7';
export const colorBackgroundTopNav = '#1f3987';
export const colorBackgroundWarning = '#fbede7';
export const colorBorderDanger = '#b4362f';
export const colorBorderDisabled = '#f4f4f5';
export const colorBorderPrimary = '#e4e6e7';
export const colorBorderSuccess = '#0b6b3d';
export const colorBorderWarning = '#f45e1e';
export const colorBrandDefault = '#0072ec';
export const colorBrandActive =
  'linear-gradient(0deg, rgba(9, 21, 33, 0.4), rgba(9, 21, 33, 0.4)), linear-gradient(90deg, #0072ec 0%, #4e00c6 163.65%, #8c18e2  191.59%)';
export const colorBrandHover =
  'linear-gradient(0deg, rgba(9, 21, 33, 0.2), rgba(9, 21, 33, 0.2)), linear-gradient(90deg, #0072ec 0%, #4e00c6 163.65%, #8c18e2  191.59%)';
export const colorBrandGradient =
  'linear-gradient(90deg, #0072ec 0%, #4e00c6 163.65%, #8c18e2  191.59%)';
export const colorDataVizDangerFill = '#e3837d';
export const colorDataVizDangerHover = '#b4362f';
export const colorDataVizDangerLine = '#d44037';
export const colorDataVizNeutralFill = '#d1d3d6';
export const colorDataVizNeutralHover = '#898e94';
export const colorDataVizPrimaryFill = '#7785db';
export const colorDataVizPrimaryFillAlt = '#c7ccf0';
export const colorDataVizPrimaryHover = '#3442bc';
export const colorDataVizPrimaryLine = '#3142c8';
export const colorDataVizSecondaryFill = '#62a9f4';
export const colorDataVizSecondaryFillAlt = '#c9e1fb';
export const colorDataVizSecondaryHover = '#005cbe';
export const colorDataVizSecondaryLine = '#0072ec';
export const colorDataVizTertiaryFill = '#b16fed';
export const colorDataVizTertiaryFillAlt = '#ddd0f3';
export const colorDataVizTertiaryHover = '#8110dc';
export const colorDataVizTertiaryLine = '#8c18e2';
export const colorDataVizWarningFill = '#ff9365';
export const colorDataVizWarningHover = '#f45e1e';
export const colorDataVizWarningLine = '#ff6422';
export const colorPaletteBlack = '#091521';
export const colorPaletteWhite = '#ffffff';
export const colorPaletteBlue50 = '#ecf4fe';
export const colorPaletteBlue100 = '#c9e1fb';
export const colorPaletteBlue200 = '#95c5f8';
export const colorPaletteBlue300 = '#62a9f4';
export const colorPaletteBlue400 = '#308df1';
export const colorPaletteBlue500 = '#0072ec';
export const colorPaletteBlue600 = '#005cbe';
export const colorPaletteBlue700 = '#00458e';
export const colorPaletteBlue800 = '#003772';
export const colorPaletteBlue900 = '#002956';
export const colorPaletteBrown50 = '#faf0e7';
export const colorPaletteBrown100 = '#ead9ce';
export const colorPaletteBrown200 = '#d8c1b2';
export const colorPaletteBrown300 = '#c4a794';
export const colorPaletteBrown400 = '#b3917b';
export const colorPaletteBrown500 = '#a27c62';
export const colorPaletteBrown600 = '#95715a';
export const colorPaletteBrown700 = '#84634f';
export const colorPaletteBrown800 = '#755646';
export const colorPaletteBrown900 = '#64473a';
export const colorPaletteGreen50 = '#ddefe6';
export const colorPaletteGreen100 = '#c3e1d2';
export const colorPaletteGreen200 = '#93c9ae';
export const colorPaletteGreen300 = '#62b08b';
export const colorPaletteGreen400 = '#329867';
export const colorPaletteGreen500 = '#0e864c';
export const colorPaletteGreen600 = '#0b6b3d';
export const colorPaletteGreen700 = '#095731';
export const colorPaletteGreen800 = '#074326';
export const colorPaletteGreen900 = '#06361e';
export const colorPaletteGrey50 = '#fafafb';
export const colorPaletteGrey100 = '#f4f4f5';
export const colorPaletteGrey200 = '#e4e6e7';
export const colorPaletteGrey300 = '#d1d3d6';
export const colorPaletteGrey400 = '#a9adb1';
export const colorPaletteGrey500 = '#898e94';
export const colorPaletteGrey600 = '#697078';
export const colorPaletteGrey700 = '#49515a';
export const colorPaletteGrey800 = '#2a343f';
export const colorPaletteGrey900 = '#091521';
export const colorPaletteIndigo50 = '#e9eafa';
export const colorPaletteIndigo100 = '#c7ccf0';
export const colorPaletteIndigo200 = '#a5aee8';
export const colorPaletteIndigo300 = '#7785db';
export const colorPaletteIndigo400 = '#5c6cd6';
export const colorPaletteIndigo500 = '#3142c8';
export const colorPaletteIndigo600 = '#3442bc';
export const colorPaletteIndigo700 = '#2e39ad';
export const colorPaletteIndigo800 = '#232b9c';
export const colorPaletteIndigo900 = '#16158d';
export const colorPaletteOrange50 = '#fbede7';
export const colorPaletteOrange100 = '#ffd0bc';
export const colorPaletteOrange200 = '#ffb291';
export const colorPaletteOrange300 = '#ff9365';
export const colorPaletteOrange400 = '#ff7b43';
export const colorPaletteOrange500 = '#ff6422';
export const colorPaletteOrange600 = '#f45e1e';
export const colorPaletteOrange700 = '#e65719';
export const colorPaletteOrange800 = '#d85015';
export const colorPaletteOrange900 = '#bf420c';
export const colorPalettePink50 = '#fbe5ee';
export const colorPalettePink100 = '#f6bed6';
export const colorPalettePink200 = '#f194ba';
export const colorPalettePink300 = '#ed6a9f';
export const colorPalettePink400 = '#ea4c89';
export const colorPalettePink500 = '#e83274';
export const colorPalettePink600 = '#d72f70';
export const colorPalettePink700 = '#c02c69';
export const colorPalettePink800 = '#aa2964';
export const colorPalettePink900 = '#852259';
export const colorPalettePurple50 = '#f2e7fc';
export const colorPalettePurple100 = '#ddd0f3';
export const colorPalettePurple200 = '#c79bf2';
export const colorPalettePurple300 = '#b16fed';
export const colorPalettePurple400 = '#9e4ae8';
export const colorPalettePurple500 = '#8c18e2';
export const colorPalettePurple600 = '#8110dc';
export const colorPalettePurple700 = '#7300d3';
export const colorPalettePurple800 = '#6500ce';
export const colorPalettePurple900 = '#4e00c6';
export const colorPaletteRed50 = '#f5e9e8';
export const colorPaletteRed100 = '#f4cfcd';
export const colorPaletteRed200 = '#eca9a5';
export const colorPaletteRed300 = '#e3837d';
export const colorPaletteRed400 = '#da5d55';
export const colorPaletteRed500 = '#d44037';
export const colorPaletteRed600 = '#b4362f';
export const colorPaletteRed700 = '#942d27';
export const colorPaletteRed800 = '#75231e';
export const colorPaletteRed900 = '#551a16';
export const colorPaletteYellow50 = '#fefae7';
export const colorPaletteYellow100 = '#fbf1c4';
export const colorPaletteYellow200 = '#f8e99f';
export const colorPaletteYellow300 = '#f4e07b';
export const colorPaletteYellow400 = '#f0d961';
export const colorPaletteYellow500 = '#ecd348';
export const colorPaletteYellow600 = '#dcc243';
export const colorPaletteYellow700 = '#c8ac3d';
export const colorPaletteYellow800 = '#b39638';
export const colorPaletteYellow900 = '#90722f';
export const colorPrimaryDefault = '#3142c8';
export const colorPrimaryActive = '#16158d';
export const colorPrimaryHover = '#2e39ad';
export const colorTextContrast = '#ffffff';
export const colorTextDanger = '#b4362f';
export const colorTextDisabled = '#a9adb1';
export const colorTextPrimary = '#091521';
export const colorTextSecondary = '#49515a';
export const colorTextSuccess = '#0b6b3d';
export const colorTextTertiary = '#898e94';
export const colorTextWarning = '#f45e1e';
export const shadowLarge =
  '0px -1px 2px rgba(61, 58, 180, 0.1), 0px 6px 14px rgba(61, 58, 180, 0.15)';
export const shadowMedium =
  '0px -1px 2px rgba(61, 58, 180, 0.1), 0px 4px 5px rgba(61, 58, 180, 0.15)';
export const shadowSmall =
  '0px -1px 2px rgba(61, 58, 180, 0.1), 0px 1px 2px rgba(61, 58, 180, 0.4)';
export const zIndexDialog = 6000;
export const zIndexDropdown = 7000;
export const zIndexModal = 9000;
export const zIndexOverlay = 8000;
export const zIndexPopover = 5000;
export const zIndexSticky = 100;
export const zIndexToast = 10000;
export const zIndexTooltip = 6000;
export const sizeLarge = '87.5rem';
export const sizeMedium = '80rem';
export const sizeSmall = '60rem';
export const sizeXLarge = '120rem';
export const sizeXSmall = '40.625rem';
export const spaceMedium = '1rem';
export const spaceSmall = '0.5rem';
export const spaceLarge = '1.5rem';
export const spaceXLarge = '2rem';
export const spaceXSmall = '0.25rem';
export const fontFamilyMono = '"Fira Mono", Courier, monospace';
export const fontFamilyText =
  '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif';
export const fontSizeLarge = '1.25rem';
export const fontSizeMedium = '1rem';
export const fontSizeSmall = '0.875rem';
export const fontSizeXLarge = '1.5rem';
export const fontSizeXSmall = '0.75rem';
export const fontSizeXxLarge = '2rem';
export const fontWeightBold = 700;
export const fontWeightRegular = 400;
export const fontWeightSemibold = 600;
export const letterSpacingLarge = '0em';
export const letterSpacingMedium = '-0.01em';
export const letterSpacingSmall = '-0.02em';
export const letterSpacingXSmall = '-0.03em';
export const lineHeightLarge = '1.875rem';
export const lineHeightMedium = '1.5rem';
export const lineHeightSmall = '1.25rem';
export const lineHeightXLarge = '2rem';
export const lineHeightXSmall = '1.125rem';
export const lineHeightXxLarge = '2.625rem';
